import React, { RefObject } from 'react';
import styles from '../CitationImportHistory.module.scss';

type Props = {
  header: React.ReactNode;
  value: React.ReactNode;
  solid?: boolean;
  clickable?: boolean;
  parentClick?: any;
};

type StatBoxRef = HTMLDivElement | HTMLButtonElement;

const StatBox = (
  {
    header,
    value,
    clickable = false,
    solid = false,
    parentClick,
    ...props
  }: Props,
  ref: React.ForwardedRef<StatBoxRef>
) => {
  const classNames = () => {
    const classes = [styles.StatBox];
    if (solid) classes.push(styles.solid);
    if (clickable) classes.push(styles.clickable);

    return classes.join(' ');
  };

  const content = (
    <>
      <div className={styles.StatBox_header}>{header}</div>
      <div className={styles.StatBox_text}>{value}</div>
    </>
  );

  if (clickable) {
    return (
      <button
        {...props}
        ref={ref as RefObject<HTMLButtonElement>}
        onClick={parentClick}
        className={classNames()}
      >
        {content}
      </button>
    );
  }

  return (
    <div
      {...props}
      ref={ref as RefObject<HTMLDivElement>}
      className={classNames()}
    >
      {content}
    </div>
  );
};

const forwardedStatBox = React.forwardRef<StatBoxRef, Props>(
  StatBox
) as React.FC<Props>;
export default forwardedStatBox;
export { forwardedStatBox as StatBox };
